// src/components/PostCard/index.jsx
import React from 'react';
import { Card, Typography, Tag, Space, Button } from 'antd';
import { UserOutlined, CalendarOutlined, EyeOutlined, HeartOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const { Paragraph, Text } = Typography;

const PostCard = ({ post, onLike, isLiked, loggedInUser }) => {
  const handleLike = () => {
    if (onLike) {
      onLike(post.id);
    }
  };

  return (
    <Card 
      className="post-card"
      hoverable
      cover={
        <div className="post-cover" style={{ 
          height: '180px', 
          backgroundImage: `url(${post.coverImage || '/default-cover.jpg'})`, 
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} />
      }
    >
      <Card.Meta
        title={
          <Link to={`/post/${post.id}`} className="post-title-link">
            <h3 className="post-title">{post.title}</h3>
          </Link>
        }
        description={
          <div className="post-meta">
            <Space size="middle" className="post-meta-info">
              <Text type="secondary">
                <UserOutlined /> {post.author}
              </Text>
              <Text type="secondary">
                <CalendarOutlined /> {new Date(post.date).toLocaleDateString('zh-CN')}
              </Text>
              <Text type="secondary">
                <EyeOutlined /> {post.views || 0} 次阅读
              </Text>
            </Space>
          </div>
        }
      />
      
      <div className="post-summary">
        <Paragraph className="post-excerpt" ellipsis={{ rows: 3, expandable: true, symbol: '更多' }}>
          {post.summary}
        </Paragraph>
      </div>
      
      <div className="post-tags">
        {post.tags && post.tags.map((tag, index) => (
          <Tag key={index} color="blue" className="post-tag">
            {tag}
          </Tag>
        ))}
      </div>
      
      <div className="post-actions">
        <Space size="middle">
          <Button 
            type={isLiked ? "primary" : "default"} 
            icon={<HeartOutlined />} 
            onClick={handleLike}
            className={isLiked ? "liked" : ""}
          >
            {isLiked ? '已喜欢' : '喜欢'}
          </Button>
          <Link to={`/post/${post.id}`}>
            <Button type="primary">阅读全文</Button>
          </Link>
        </Space>
      </div>
    </Card>
  );
};

export default PostCard;